// extracted by mini-css-extract-plugin
export var deliveryRow = "_sx-a";
export var fixedHeight = "_sx-4";
export var freightLogo = "_sx-9";
export var fullWidth = "_sx-3";
export var priceColumn = "_sx-5";
export var radioSelected = "_sx-7";
export var radioUnselected = "_sx-6";
export var selectedOption = "_sx-2";
export var selectedOptionContainer = "_sx-1";
export var selection = "_sx-0";
export var tallSkeletonText = "_sx-8";